export enum UserManageColumn {
    SITE = 'Site',
    REGION = 'Region'
}

export enum ENTITY {
    WAREHOUSE = 'warehouse',
    EMAIL = 'email'
}
